import * as React from "react";
import cn from "classnames";
import { useTabsContext } from "../tabs-context";

interface DisabledTabPanelProps {
  children?: React.ReactNode;
  className?: string;
}

const DisabledTabPanel: React.FC<DisabledTabPanelProps> = ({
  className,
  children,
  ...rest
}) => {
  const { getBemBlocksWith } = useTabsContext();

  return (
    <section
      {...rest}
      className={cn(
        className,
        getBemBlocksWith("__tab-panel"),
        getBemBlocksWith("__tab-panel--disabled"),
      )}
    >
      {children}
    </section>
  );
};

export default DisabledTabPanel;
